import { render } from "./TwoFactorWarning.vue?vue&type=template&id=3280945a&scoped=true"
import script from "./TwoFactorWarning.vue?vue&type=script&lang=js"
export * from "./TwoFactorWarning.vue?vue&type=script&lang=js"

import "./TwoFactorWarning.vue?vue&type=style&index=0&id=3280945a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3280945a"]])

export default __exports__